
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanInputCell/LeanInputCell.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanInputCell.html');
        
        var script = require('./LeanInputCell.ts').default;
        module.exports = require('./LeanInputCell.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    